export default "__VITE_ASSET__CRL1mqGr__"